// extracted by mini-css-extract-plugin
export default {"menuTitle":"ActiveItem_menuTitle__d7Gjr","menuDesc":"ActiveItem_menuDesc__3dytP","menuItem":"ActiveItem_menuItem__ckfsr","menuItemChild":"ActiveItem_menuItemChild__x3Zey"};